import React from 'react';
import NavigationCard from '@ajat/design-system/NavigationCard';
import { ComponentPage, DemoCard } from '../shared';
import { DEMO_NAV_ITEMS } from './demoData';
import editionsImg from '@ajat/design-system/assets/overall/side-menu/editions.jpg';
import patchImg from '@ajat/design-system/assets/overall/side-menu/patch-universe.png';

const CARDS = DEMO_NAV_ITEMS.CLS[0].submenu.columns.filter((c) => c.type === 'card');

export const meta = {
  component: NavigationCard,
  title: 'Navigation Card',
  group: 'Navigation',
  importPath: '@ajat/design-system/NavigationCard',
  description:
    'Image card with either a button or an arrow link underneath. It fills the desktop mega-menu columns (capped at 276px) and goes full width as the promo card in the mobile drawer — the same component in both places, sized by its container.',
  props: [
    ['image', 'string', '—', 'Image source (required)'],
    ['imageAlt', 'string', "''", 'Alt text'],
    ['type', "'button' | 'link'", "'button'", 'Button renders a secondary Button; link renders a Hyperlink with an arrow'],
    ['label', 'string', '—', 'Button or link label (required)'],
    ['href', 'string', "'#'", 'Link target'],
    ['onClick', 'func', '—', 'Click handler'],
    ['card', 'bool', 'false', 'M2 card skin (OVER-LL SideMenu): gray-025 surface, gray-0 hairline, card shadow, small-l padding; fills its container'],
    ['imageFit', "'cover' | 'contain'", "'cover'", "'contain' centres a cut-out (patch PNG) on a white well"],
    ['showArrow', 'bool', 'true', 'Link type: the arrow after the label'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'In a mega-menu column',
      code: `// Header builds these from navItems[].submenu.columns
const navItems = [{
  label: 'STUDIETURTRØJE',
  submenu: {
    columns: [
      { type: 'card', cardType: 'button', image: hero, label: 'BESTIL', href: '#' },
      { type: 'card', cardType: 'link', image: guide, label: 'Size Guide', href: '#' },
      { type: 'links', items: [{ label: 'FAQ', href: '/faq' }] },
    ],
  },
}];`,
    },
    {
      title: 'Standalone',
      code: `import NavigationCard from '@ajat/design-system/NavigationCard';

<NavigationCard
  image={heroImage}
  imageAlt="Studieturstrøjer"
  type="button"
  label="BESTIL STUDIETURTRØJER"
  onClick={() => onMenuItemClick('menu_1')}
/>`,
    },
  ],
};

export default function NavigationCardPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Types" hint="button and link, side by side">
        <div className="flex flex-wrap gap-[var(--space-ui-medium-m)]">
          <div style={{ width: 276, maxWidth: '100%' }}>
            <NavigationCard image={CARDS[0].image} imageAlt={CARDS[0].imageAlt} type="button" label="BESTIL STUDIETURTRØJER" href="#" />
          </div>
          <div style={{ width: 276, maxWidth: '100%' }}>
            <NavigationCard image={CARDS[1].image} imageAlt={CARDS[1].imageAlt} type="link" label="Create your logotype" href="#" />
          </div>
        </div>
      </DemoCard>

      <DemoCard title="A mega-menu row" hint="three cards, each capped at 276px">
        <div className="flex flex-wrap gap-[var(--space-ui-medium-m)]">
          {CARDS.map((card, i) => (
            <div key={card.label} style={{ width: 276, maxWidth: '100%' }}>
              <NavigationCard
                image={card.image}
                imageAlt={card.imageAlt}
                type={i === 0 ? 'button' : 'link'}
                label={card.label}
                href="#"
              />
            </div>
          ))}
        </div>
      </DemoCard>

      <DemoCard title="Card skin" hint="card — as in the OVER/LL side menu (switch the brand to Overall)">
        <div className="flex flex-wrap gap-[var(--space-ui-medium-m)] items-start">
          <div style={{ width: 352, maxWidth: '100%' }}>
            <NavigationCard card image={editionsImg} imageAlt="Designa editions" type="button" label="DESIGNA EDITIONS" href="#" />
          </div>
          <div style={{ width: 168, maxWidth: '100%' }}>
            <NavigationCard card imageFit="contain" showArrow={false} image={patchImg} imageAlt="" type="link" label="Patch Universe" href="#" />
          </div>
        </div>
      </DemoCard>

      <DemoCard title="Full width" hint="how it renders as the mobile drawer promo">
        <div style={{ maxWidth: 360 }}>
          <NavigationCard image={CARDS[0].image} imageAlt={CARDS[0].imageAlt} type="button" label="BESTIL STUDIETURTRØJER" href="#" />
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
